import {Component, effect, input, output, signal, untracked} from '@angular/core';
import {SharedModule} from '../../modules/shared.module';
import {form, FormField, max, maxLength, required} from '@angular/forms/signals';
import {CropperComponent} from '../cropper/cropper';
import {isEqual} from 'lodash';

interface ChatSetting {
  id?: number;
  status: boolean;
  room_title: string;
  room_avatar: string;
  room_avatar_file: File | null;
  room_color: string;
  room_id?: string;
}

const initialData: ChatSetting = {
  status: false,
  room_title: '',
  room_avatar: '',
  room_color: '',
  room_avatar_file: null
};

@Component({
  selector: 'chat-setting',
  templateUrl: './chat-setting.component.html',
  styleUrls: ['./chat-setting.component.scss'],
  standalone: true,
  imports: [SharedModule, FormField, CropperComponent]
})

export class ChatSettingComponent {
  chatModel = signal<ChatSetting>(initialData);
  chatForm = form(this.chatModel, (chat => {
    maxLength(chat.room_title, 25, {message: 'chat.max_length_25'});
  }));
  chatData = input<any>();

  chatFormResult = output<ChatSetting>();

  cropperOpened = output<boolean>();

  constructor() {
    effect(() => {
      const result = this.chatModel();
      untracked(() => {
        this.chatFormResult.emit(result);
      });
    });

    effect(() => {
      const newData = this.chatData();
      if (newData) {
        const currentModel = untracked(() => this.chatModel());

        if (!isEqual(currentModel, newData)) {
          untracked(() => {
            this.chatModel.update(e => ({...e, ...newData}));
          });
        }
      }
    });
  }

  getRoomAvatar(e) {
    this.chatModel.update(prev => ({...prev, room_avatar_file: e}));
  }

  openCropper(e) {
    this.cropperOpened.emit(e);
  }

  onSettingsChange(event) {
    this.chatModel.update(prev => ({...prev, room_color: event.bg}));
  }
}
